export default {"src":"/_next/static/media/verified.8b24c936.svg","height":20,"width":20};